authHttpResponseInterceptor.$inject = ["$q"];

function authHttpResponseInterceptor($q) {

	return {
		// request: function onRequest(config) {
		// 	config.ignoreLoadingBar= true;
		// 	return $q.when(config);
		// },

		response: function (response) {
			if (response.status === 401) {
				console.log("Response 401");
				// location.hash = "";
				// location.pathname = "/";
                location.href = `${location.origin}/#!/Authentication/UserLogin?returnUrl=${encodeURIComponent(location.href)}`
			}
			return response || $q.when(response);
		},
		responseError: function (rejection) {
			if (rejection.status === 401) {
				console.log("Response Error 401", rejection);
				// location.hash = "";
				// location.pathname = "/";
                location.href = `${location.origin}/#!/Authentication/UserLogin?returnUrl=${encodeURIComponent(location.href)}`
			}
			return $q.reject(rejection);
		}
	}

}
module.exports = ngModule => {
	ngModule.factory('authHttpResponseInterceptor', authHttpResponseInterceptor);
};